import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@brunata-angular/util';

@Pipe({
    name: 'shutoffvalve',
    standalone: true,
})
export class ShutoffValvePipe implements PipeTransform {
    private translateService = inject(TranslateService);

    transform(value: string | null): string {
        if (value === null) {
            return '';
        }

        switch (value) {
            case 'B':
                return this.translateService.translate('utilities_.BEFORE');
            case 'A':
                return this.translateService.translate('utilities_.AFTER');
            case 'M':
                return this.translateService.translate('utilities_.BOTH');
            case 'N':
                return this.translateService.translate('utilities_.NONE');
            default:
                return value;
        }
    }
}
